import { Fragment, useEffect, useState } from 'react';

/* MUI */
import { Accordion, AccordionDetails, AccordionSummary, Grid, TextField, Typography } from '@material-ui/core';

import FormInputTypography from '../../form-input/form-input-typography.component';

const ServiceAgreementAppeal = (props) => {
  const [data, setData] = useState({
    accounts: [],
    f_Applicant_Comments: ""
  })

  const [area, setArea] = useState({
    mapBlkLot: "",
    grossTotalArea: "",
    permeableArea: "",
    impermeableArea: "",
    excludedArea: "",
  });

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }

    if (props.area) {
      setArea(props.area);
    }
  }, [props])

  return (
    <Accordion expanded>
      <AccordionSummary id="SAChargeAllocAppeal" style={{ backgroundColor: "whitesmoke" }}>
        <Typography variant="h6" align="center" gutterBottom color="primary">
          Information for Revised Service Agreement Charge Allocations Appeal
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {/* <Typography variant="h6" color="error">
              There is a CURRENT APPEAL PENDING. Please contact us at ZZZ-ZZZ-ZZZZ before submitting a new request.
            </Typography> */}
            <Typography variant="body1" color="textSecondary">
              In accordance with SFPUC Policies, the allocation of the stormwater charge will be equally distributed amongst the properties within the Map Block Lot.
              All property owners must submit one appeal for an alternative Stormwater Charge Allocation for the water accounts on their property for their Map Block Lot.
            </Typography>
          </Grid>

          <Grid item xs={6} align="center">
            <Typography variant="h6" color="textPrimary">
              {area.mapBlkLot}
            </Typography>
            <Typography variant="body2">Map Block Lot</Typography>
          </Grid>

          {/* <Grid item xs={4} align="center">
            <Typography variant="h6" color="textPrimary">4</Typography>
            <Typography variant="body2">Number of SAs on Map Block Lot</Typography>
          </Grid> */}
          <Grid item xs={6} align="center">
            <Typography variant="h6" color="textPrimary">{data.accounts.length}</Typography>
            <Typography variant="body2">Number of Service Agreements</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography>Account Number</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography>Charge (%)</Typography>
          </Grid>

          {data.accounts.length > 0 && data.accounts.map((element, index) =>
          (<Fragment key={index} >
            <Grid item xs={6} align="center">
              <TextField name="acc_no" variant="outlined" fullWidth label={`Account Number ${index + 1}`}
                value={element.f_Appeal_Account_Num} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={6} align="center">
              <TextField name="acc_charge" variant="outlined" label="Charge" fullWidth
                value={element.f_Appealed_Distb_Percent} InputProps={{ readOnly: true }} />
            </Grid>
          </Fragment>)
          )}

          <FormInputTypography
            label="Charge Allocations Appeal ID"
            size={5}
            value={data.customerAppealId}
          />
          <FormInputTypography
            label="Applicant Comments"
            size={5}
            value={data?.f_Applicant_Comments ? data.f_Applicant_Comments : ""}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default ServiceAgreementAppeal;